__turbopack_context__.v({
  "emptyState": "component-module__fXLG2a__emptyState",
  "grid": "component-module__fXLG2a__grid",
  "gridCompact": "component-module__fXLG2a__gridCompact",
  "nowPlaying": "component-module__fXLG2a__nowPlaying",
  "nowPlayingCount": "component-module__fXLG2a__nowPlayingCount",
  "nowPlayingHeader": "component-module__fXLG2a__nowPlayingHeader",
  "nowPlayingItem": "component-module__fXLG2a__nowPlayingItem",
  "nowPlayingList": "component-module__fXLG2a__nowPlayingList",
  "nowPlayingTitle": "component-module__fXLG2a__nowPlayingTitle",
  "root": "component-module__fXLG2a__root",
  "rootCompact": "component-module__fXLG2a__rootCompact",
  "statIcon": "component-module__fXLG2a__statIcon",
  "statLabel": "component-module__fXLG2a__statLabel",
  "statTile": "component-module__fXLG2a__statTile",
  "statTileCompact": "component-module__fXLG2a__statTileCompact",
  "statValue": "component-module__fXLG2a__statValue",
  "trackArtist": "component-module__fXLG2a__trackArtist",
  "trackInfo": "component-module__fXLG2a__trackInfo",
  "trackTitle": "component-module__fXLG2a__trackTitle",
  "trackUser": "component-module__fXLG2a__trackUser",
});
